import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AnalyticsService, AnalyticsUtility } from 'src/app/services/analytics/analytics.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { FilterMappingService } from 'src/app/services/results/filter-mapping.service';
import { constants } from 'src/environments/constants';

@Component({
  selector: 'app-screen-size-filters',
  templateUrl: './screen-size-filters.component.html',
  styleUrls: ['./screen-size-filters.component.scss']
})
export class ScreenSizeFiltersComponent implements OnInit {
  @Output() screenSizesToFilterBy: EventEmitter<number[]> = new EventEmitter();
  selectedScreenSizes: number[] = [];
  title: string = "";
  screenSizeFilterRanges: number[][] = [];

  constructor(private analytics: AnalyticsService, private confSvc: ConfigService, public filterMapper: FilterMappingService) { }

  async ngOnInit(): Promise<void> {
    await this.confSvc.setup();

    this.title = this.confSvc.getString("screenSizesFilterTitle");
    this.screenSizeFilterRanges = [
      constants.TEN_ELEVEN_SCREEN_SIZE_RANGE,
      constants.TWELVE_THIRTEEN_SCREEN_SIZE_RANGE,
      constants.FOURTEEN_FIFTEEN_SCREEN_SIZE_RANGE
    ];
  }

  screenSizeRangeIsSelected(sizes: number[]) {
    return sizes.every(size => this.selectedScreenSizes.includes(size));
  }

  onScreenSizeFilterChange(sizes: number[]) {
    let indexOfScreenSize = 0;
    sizes.forEach(item => {
      indexOfScreenSize = this.selectedScreenSizes.indexOf(item);
      indexOfScreenSize < 0 ? this.selectedScreenSizes.push(item) : this.selectedScreenSizes.splice(indexOfScreenSize, 1);
    });
    this.screenSizesToFilterBy.emit(this.selectedScreenSizes);
    this.analytics.logCheckboxFilterClick(AnalyticsUtility.filterType.screenSize, sizes, indexOfScreenSize < 0);
  }

}
